// 例如 next-i18next.config.js
const path = require('path');

module.exports = {
  i18n: {
    locales: ['en', 'es', 'pt', 'ja', 'ko', 'de', 'it', 'th'],
    defaultLocale: 'en',
    localeDetection: false,
  },
  localesPath: path.resolve('./public/locales'),
};
